























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

/**
 *
 *  Holding the details of an image of the system.
 *
 *  (i) Images are set as cover backgrounds of elements,
 *  so a width and height aren't needed
 *
 */
export interface SystemImage {
    /** Title for the element of the image (if present). */
    title: string | null;

    /** The public source of the image. */
    src: string;
}

/**
 *  Holding the breakpoints at which the images should resize.
 */
const SMALL_SCREEN = 660;
const LARGE_SCREEN = 998;

/**
 *  Component that renders the image gallery
 *  for a system, including the controls.
 */
@Component
export default class SystemImages extends Vue {

    @Prop({ type: Array, required: true })
    private images!: Array<SystemImage>;

    /**
     *  Holding the index (Array counting) of the
     *  image that is currently shown.
     */
    private current = 0;

    /**
     *  Holding the width of the images wrapper.
     */
    private width = 10;

    /**
     *  Holding the size of an image, used for both height as width.
     */
    private imageSize = 9;

    /**
     *  Used to determine if the navigation should be shown.
     */
    private get showNav(): boolean {

        return this.images.length > 1;

    }

    /**
     *  Resize the images on resize.
     */
    private mounted(): void {

        this._resize();

        window.addEventListener('resize', this._resize.bind(this));

    }

    private beforeDestroy(): void {

        window.removeEventListener('resize', this._resize.bind(this));

    }

    /**
     *
     *  Used to navigate to the previous image.
     *
     *  (i) Navigates to the last image if the first
     *  one is shown to create an infinite loop
     *
     */
    private previous(): void {

        this.current = this.current > 0
            ? this.current - 1
            : this.images.length - 1;

    }

    /**
     *
     *  Used to navigate to the next image.
     *
     *  (i) Navigates to the first image if the last
     *  one is shown to create an infinite loop
     *
     */
    private next(): void {

        this.current = this.current === this.images.length - 1
            ? 0
            : this.current + 1;

    }

    /**
     *  Used to resize the images, based on the width of the viewport.
     */
    private _resize(): void {

        const clientWidth: number = document.documentElement.clientWidth;

        if (clientWidth < SMALL_SCREEN) {

            this.width = 17;
            this.imageSize = 14;

            return;

        }

        this.width = clientWidth > LARGE_SCREEN ? 13 : 10;
        this.imageSize = clientWidth > LARGE_SCREEN ? 11 : 9;

    }

}
